import { snakeCase } from 'lodash'

export const featureLinksMixin = {
  methods: {
    getLocationProps(feature) {
      const { location } = feature

      if (location.shortcut) {
        return { to: this[location.shortcut].apply(this, location.arguments || []) }
      } else {
        return location
      }
    },

    handleFeatureClick(feature) {
      const formattedTitle = snakeCase(feature.title)
      this.$posthog.capture('icons_landing:feature_link_click', { feature: formattedTitle })
    }
  }
}
